import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Your transaction overview',
  description:
    'These are your transaction details. Make sure to check if this is correct before submitting.',
  unstake: 'Unstake',
  unstakeAsset: 'Unstake {asset}',
  boxDescription: 'Please submit to unstake',
  backToStaking: 'Back to staking',

  blockingError: 'Staked amount are less',
});
